import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import aboutus from './Images/aboutus.jpg'
const Aboutus = () => {
  return (
    <React.Fragment>
      <Box
        sx={{
          mt: 8,
        }}
      >
        <Typography
          sx={{
            background: `linear-gradient(#212245b2,#212245b2),url("aboutus.avif")`,
            backgroundRepeat: "no-repeat",
            padding: "80px 0",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100px",
            color: "white",
            fontSize: "2.5rem",
            textAlign: "center",
          }}
        >
          Welcome to Bella Store
        </Typography>
      </Box>
      <Container>
        <Typography textAlign={"center"} mt={4} sx={{ fontSize: "1.8rem" }}>
          About Us
        </Typography>
        <Typography textAlign={"center"} mt={1} sx={{ fontSize: "1.1rem" }}>
          Welcome to our fashion haven! At our clothing store, we offer a
          curated selection of stylish apparel to suit every taste and occasion.
          From casual chic to elegant sophistication, discover your perfect look
          with us today.
        </Typography>
        <Grid container spacing={2} sx={{ marginTop: "auto" }}>
          <Grid item xs={12} lg={8} md={6}>
            <Box
              component="img"
              src={aboutus}
              sx={{
                width: "100%",
                height: { lg: 400, md: 400, xs: 400,sm:400 },
                objectFit: "cover",
                mt: { lg: 8, xs: 3 },
                borderRadius: "35px",boxShadow:24,
              }}
            />
          </Grid>
          <Grid item xs={12} lg={4} md={6}>
            {" "}
            <Typography
              sx={{ mt: { lg: 18, xs: 5 }, fontSize: "1.1rem", ml: 2,}}
            >
              At Bella Store, we are passionate about fashion and dedicated to
              providing our customers with the latest trends and timeless
              styles. With a focus on quality, affordability, and exceptional
              customer service, we strive to empower individuals to express
              their unique sense of style. Join us in celebrating fashion and
              self-expression at Bella Store.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default Aboutus;
